import type { ItineraryService } from '../../../../mocks/itinerary';
import { serviceTypeConfig } from '../../../../mocks/itinerary';
import { agencyInfo } from '../../../../mocks/dashboard';

const brand = agencyInfo.brandColor;

interface Props {
  service: ItineraryService;
  onEdit: () => void;
  onDelete: () => void;
}

export default function ServiceItem({ service, onEdit, onDelete }: Props) {
  const cfg = serviceTypeConfig[service.type];

  return (
    <div className="group flex items-start gap-3 bg-white border border-gray-100 rounded-xl p-3 hover:border-gray-200 transition-all">
      {/* Icon */}
      <div
        className="w-9 h-9 rounded-lg flex items-center justify-center flex-shrink-0 mt-0.5"
        style={{ backgroundColor: cfg.bg, color: cfg.color }}
      >
        <i className={`${cfg.icon} text-base`} />
      </div>

      {/* Content */}
      <div className="flex-1 min-w-0">
        <div className="flex items-start justify-between gap-2">
          <div className="flex-1">
            <div className="flex items-center gap-2 flex-wrap">
              <p className="text-sm font-medium text-gray-800 leading-tight">{service.name}</p>
              <span
                className="text-xs px-1.5 py-0.5 rounded-full font-medium"
                style={{ backgroundColor: cfg.bg, color: cfg.color }}
              >
                {service.type}
              </span>
              {service.time && (
                <span className="text-xs text-gray-400 flex items-center gap-1">
                  <i className="ri-time-line" />
                  {service.time}
                </span>
              )}
            </div>
            {service.description && (
              <p className="text-xs text-gray-400 mt-1 line-clamp-2">{service.description}</p>
            )}
            {service.notes && (
              <p className="text-xs text-amber-600 mt-1 flex items-center gap-1">
                <i className="ri-information-line" />
                {service.notes}
              </p>
            )}
          </div>

          {/* Actions */}
          <div className="flex items-center gap-1 opacity-0 group-hover:opacity-100 transition-opacity flex-shrink-0">
            <button
              onClick={onEdit}
              className="w-7 h-7 flex items-center justify-center rounded-lg hover:bg-gray-100 text-gray-400 cursor-pointer"
            >
              <i className="ri-edit-line text-sm" />
            </button>
            <button
              onClick={onDelete}
              className="w-7 h-7 flex items-center justify-center rounded-lg hover:bg-red-50 text-gray-400 hover:text-red-500 cursor-pointer"
            >
              <i className="ri-delete-bin-line text-sm" />
            </button>
          </div>
        </div>

        {/* Pricing row */}
        {(service.costPrice > 0 || service.sellPrice > 0) && (
          <div className="flex items-center gap-3 mt-2">
            <span className="text-xs text-gray-400">
              Cost: <span className="text-gray-600 font-medium">AED {service.costPrice.toLocaleString()}</span>
            </span>
            <span className="text-gray-200">|</span>
            <span className="text-xs text-gray-400">
              Sell: <span className="text-gray-700 font-semibold">AED {service.sellPrice.toLocaleString()}</span>
            </span>
            {service.sellPrice > 0 && (
              <>
                <span className="text-gray-200">|</span>
                <span
                  className="text-xs font-semibold"
                  style={{ color: brand }}
                >
                  +AED {(service.sellPrice - service.costPrice).toLocaleString()}
                </span>
              </>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
